import {useEffect, useRef} from 'react'
import {useTranslation} from 'react-i18next'

// Reads only the existing access endpoint. Does not enqueue provider requests.
const PlanetHdHistoricalProgress = ({progress, landId, geometryHash, refresh}) => {
  const {t} = useTranslation()
  const pending = useRef(false)
  const active = Boolean(progress)
  useEffect(() => {
    if (!active || !refresh || !landId) return undefined
    let disposed = false
    const timer = window.setInterval(async () => {
      if (disposed || pending.current || document.hidden) return
      pending.current = true
      try { await refresh(landId, {force: true, geometryHash, background: true}) }
      catch (_) { /* Preserve the last known progress on transient failures. */ }
      finally { pending.current = false }
    }, 30000)
    return () => { disposed = true; window.clearInterval(timer) }
  }, [active, landId, geometryHash, refresh])
  if (!progress) return null
  const total = Number.isFinite(progress.total) ? Math.max(0, progress.total) : 0
  const ready = Math.min(total, Number.isFinite(progress.ready) ? Math.max(0, progress.ready) : 0)
  const paused = progress.state === 'budget_paused'
  return <div className="alert alert-primary mt-3 mb-3 mx-3" role="status" aria-live="polite">
    <div>{total > 0
      ? t('images:hd_dates.history_progress', {ready, total,
        defaultValue: `Histórico HD: ${ready} de ${total} fechas listas para visualizar.`})
      : progress.state === 'complete'
        ? t('images:hd_dates.history_empty', {defaultValue: 'No hay fechas HD disponibles en la ventana de acceso.'})
        : t('images:hd_dates.history_inventory', {defaultValue: 'Consultando las fechas del histórico HD.'})}</div>
    {total > 0 && <progress className="w-100" value={ready} max={total}
      aria-label={t('images:hd_dates.history_label', {defaultValue: 'Preparación del histórico HD'})}/>}
    {paused && <small>{t('images:hd_dates.history_budget', {
      defaultValue: 'Preparación automática pausada por el límite de presupuesto. Las imágenes listas siguen disponibles.',
    })}</small>}
    {progress.pending > 0 && !paused && <small>{t('images:hd_dates.history_background', {
      defaultValue: 'Se prepara en segundo plano, empezando por las fechas recientes. Podés seguir usando el lote.',
    })}</small>}
    {progress.unavailable > 0 && <div><small>{t('images:hd_dates.history_unavailable', {
      count: progress.unavailable,
      defaultValue: `${progress.unavailable} fechas sin cobertura suficiente. No se rellenan píxeles faltantes.`,
    })}</small></div>}
    {progress.failed > 0 && <div><small>{t('images:hd_dates.history_failed', {
      count: progress.failed, defaultValue: `${progress.failed} fechas requieren revisión de la preparación.`,
    })}</small></div>}
  </div>
}

export default PlanetHdHistoricalProgress
